import "./Dashboard.css";


function Dashboard(){


return(

<div className="dashboard">


<h1>
Dashboard 📊
</h1>


<div className="dashboard-cards">


<div>

<h2>
120
</h2>

<p>
Orders
</p>

</div>



<div>

<h2>
35
</h2>

<p>
Products
</p>

</div>




<div>

<h2>
500$
</h2>

<p>
Sales
</p>

</div>


</div>


</div>

)


}


export default Dashboard;